import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';

import spriteLibraryContent from '../lib/libraries/sprites.json';
import randomizeSpritePosition from '../lib/randomize-sprite-position';
import spriteTags from '../lib/libraries/sprite-tags';

import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    async handleItemSelect (item) {
        // Make a copy so original library data is not changed
        const sprite = JSON.parse(JSON.stringify(item));

        // Load locally hosted costume images into Scratch Storage
        const storage = this.props.vm.runtime.storage;

        await Promise.all(sprite.costumes
            .filter(costume => costume.rawURL)
            .map(async costume => {
                const response = await fetch(costume.rawURL);

                if (!response.ok) {
                    throw new Error(`Could not load costume: ${costume.rawURL}`);
                }

                const data = new Uint8Array(await response.arrayBuffer());

                const assetType = costume.dataFormat === 'svg' ?
                    storage.AssetType.ImageVector :
                    storage.AssetType.ImageBitmap;

                const dataFormat = costume.dataFormat === 'svg' ?
                    storage.DataFormat.SVG :
                    storage.DataFormat.PNG;

                storage.builtinHelper._store(
                    assetType,
                    dataFormat,
                    data,
                    costume.assetId
                );
            }));

        // Randomize position of library sprite
        randomizeSpritePosition(sprite);

        // MadBot: set default size of selected sprites
        sprite.size = 100;

        await this.props.vm.addSprite(JSON.stringify(sprite));
        this.props.onActivateBlocksTab();
    }

    render () {
        return (
            <LibraryComponent
                data={spriteLibraryContent}
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(SpriteLibrary);